module.exports = __webpack_public_path__ + "static/media/21ECLAC43.0ff5e56f.jpg";